// [343] LAS SIETE CATEGORÍAS POR EDAD, en un solo sitio para el panel.
//
// La lista vive a la vez en el CHECK `groups_category_check` de la base —que es
// LA AUTORIDAD— y en varios mapas del frontend. Este módulo existe para no
// seguir multiplicándolos: la ficha del alumno y la lista de alumnos lo
// importan de aquí en vez de copiarlo cada una.
//
// ⚠️ ESTE FICHERO ESTÁ REGISTRADO en `supabase/__tests__/categorias-grupo.test.ts`,
// que compara todas las copias contra la última migración que redefine el CHECK
// y falla si alguna divergiera. Si añades una categoría a la base, ese test te
// dirá que falta aquí.
//
// EL ORDEN ES EL DEL DESPLEGABLE: de la categoría más joven a la mayor, y el
// test también lo comprueba.
export const CATEGORY_LABELS: Record<string, string> = {
  querubin: 'Querubín',
  prebenjamin: 'Prebenjamín',
  benjamin: 'Benjamín',
  alevin: 'Alevín',
  infantil: 'Infantil',
  cadete: 'Cadete',
  juvenil: 'Juvenil',
};

/** Las claves, en el orden de presentación. */
export const CATEGORIAS = Object.keys(CATEGORY_LABELS);
